import { Injectable } from '@angular/core';
import { AngularFireRemoteConfig } from '@angular/fire/compat/remote-config';

type ConfigType = 'boolean' | 'string' | 'number';
@Injectable({
	providedIn: 'root',
})
export class RemoteConfigService {
	/*
	 **-------------------------------------------------------------------------------------
	 ** METHOD NAME - constructor
	 **-------------------------------------------------------------------------------------
	 */
	constructor(private remoteConfig: AngularFireRemoteConfig) {}
	/*
	 **-------------------------------------------------------------------------------------
	 ** METHOD NAME - init
	 **-------------------------------------------------------------------------------------
	 */
	public async init() {
		await this.remoteConfig.fetchAndActivate();
	}
	/*
	 **-------------------------------------------------------------------------------------
	 ** METHOD NAME - getValuesByKey
	 **-------------------------------------------------------------------------------------
	 */
	public async getValueByKey(key: string, type: ConfigType = 'string'): Promise<any> {
		let value;
		if (type === 'boolean') value = await this.remoteConfig.getBoolean(key);
		if (type === 'number') value = await this.remoteConfig.getNumber(key);
		if (type === 'string') value = await this.remoteConfig.getString(key);
		return value;
	}
}
